// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Qo-z","imageAndVideoCount":"Ro-z","imageAndVideoContainer":"So-z","viewAllReviews":"To-z"};